import { type VolunteeringRecordDto } from "@crowdcoursing/api/openapi";
import { Box, Typography } from "@mui/material";

import { Volunteers } from "~ui/organisms/DataGrid/Volunteers/Volunteers";

const tVolunteerRecords = "Volunteer Records";

export interface UserHistoryVolunteersProps {
  data: VolunteeringRecordDto[];
  /** When true, hide the "Volunteer Records" title (e.g. when used in a widget that has its own title) */
  hideTitle?: boolean;
  userId?: string;
}

export const UserHistoryVolunteerRecords = ({ data, hideTitle = false, userId }: UserHistoryVolunteersProps) => {
  const status = data.length != null && data.length !== undefined ? "success" : "pending";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minWidth: 0, width: "100%" }}>
      {!hideTitle && (
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ mb: 1 }} variant="h5">
            {tVolunteerRecords}
          </Typography>
        </Box>
      )}
      <Box sx={{ flexGrow: 1, height: "100%", minHeight: 0, minWidth: 0, overflow: "auto" }}>
        <Volunteers data={data} status={status} userId={userId} />
      </Box>
    </Box>
  );
};
